import type { DidConnectAnonStatusDatagramBuf } from "~/classes/generated/status"

import { parseAnonymousIdBuf } from "~/utils/flatbuffers/anonymous"

const console = useLogger("status/connect-anon")

export function handleDidConnectAnonStatusDatagramBuf(buf: DidConnectAnonStatusDatagramBuf) {
  const { emitInterfaceEvent } = useEvents()
  const { cacheState, onConnectedAnon } = useCache()

  const datagram: DidConnectAnonStatusDatagram = {
    anonId: parseAnonymousIdBuf(buf.anonId()!),
    epochId: buf.epochId(),
  }

  // on connection (which might be duplicate due to e.g. a 2nd tab?), we want to
  // kick off any next state actions there might be, for example loading the
  // page in question.

  if (
    cacheState.value.epochId === datagram.epochId
    && cacheState.value.status === "readyAnon"
    && cacheState.value.anonId === datagram.anonId
  )
    return console.warn("Received duplicate connection update, skipping any setup")

  console.debug("Successful anonymous connection to cache", datagram)
  onConnectedAnon(datagram)
  emitInterfaceEvent("didConnectAnonStatus", datagram)
}
